import React, { useState } from 'react';

import PageHeading from '../../../../components/common/PageHeading';
import ConfirmationBox from '../../../../components/common/ConfirmationBox';
import RightBar from '../../../../components/common/RightBar';

import { portfolios } from '../../../../data/portfolios';

import { MdOutlineRemoveCircle } from 'react-icons/md';
import { Col, Row, Table } from 'antd';

import './Portfolio.css'
import { toast } from 'react-hot-toast';

const PortfolioRightBar = [];

function Portfolio() {

  const [portfoliosData, setPortfoliosData] = useState(portfolios);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [recordId, setRecordId] = useState(0);
  const [portfolioName, setPortfolioName] = useState("");
  const [portfolioProperties, setPortfolioProperties] = useState("");

  const columns = [
    {
        dataIndex:"name",
        title: "Name",
        key:"1",
        render: (text, record) => (
          <>
            {text}
            {
             setPortfolioName(record.name)
            }
          </>
        )
    },
    {
        dataIndex:"properties",
        title: "Properties",
        key:"2",
        render: (text, record) => (
          <>
            <span className="onclick-text">{text}</span>
            {
              setPortfolioProperties(record.properties)
            }
          </>
        )
    },
    {
        dataIndex:"address",
        title: "Address",
        key:"3", 
    },
    {
        dataIndex:"phoneNumber",
        title: "Phone Number",
        key:"4",
        render: (text) => <span className="onclick-text">{text}</span>
    },
    {
      dataIndex:"action",
      title: "Action",
      key:"5",
      render: (text, record) => <MdOutlineRemoveCircle size={16} className='delete-icon' onClick={()=>openConfirmationBox(record)}/>
  },
];

const openConfirmationBox = (record) => {
  setIsConfirmationBoxOpen(true);
  setRecordId(record.id);
}

  const deletePortfolio = (record) => {
    try{
      const filteredPortfolios = portfoliosData.filter((portfolio)=>{
        return portfolio.id !== record
      });
      setPortfoliosData(filteredPortfolios);
      setIsConfirmationBoxOpen(false);
      toast.success("Deleted Successfully");
    }
    catch(err){
      toast.error(err.message);
    }
  }

  console.log(portfoliosData);

  return (
    <>
      <Row>
      <Col span={24} >
        <PageHeading heading="Portfolios" />
        <Table dataSource={portfoliosData} columns={columns} />
      </Col>
    </Row>
    <div className="RightSidebar">
      <RightBar RightBarData={PortfolioRightBar}/>
    </div>
    {isConfirmationBoxOpen ? (
      <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
        <h2>Please Confirm</h2>
        <p className='message'>The rhetttullis portfolio contains {portfolioProperties} properties. When a portfolio is deleted, the portfolio's properties revert to using your company logo and settings. </p>
        <p className='message'>
          Are you sure you want to delete the {portfolioName} portfolio?
        </p>
        <div className="action-buttons">
          <button
            className="red"
            onClick={() => deletePortfolio(recordId)}
          >
            Deleted
          </button>
          <button
            className="cancel-btn"
            onClick={() => setIsConfirmationBoxOpen(false)}
          >
            Cancel
          </button>
        </div>
      </ConfirmationBox>
    ) : null}
    </>
  )
}

export default Portfolio;
